<template>
    <div v-loading="loadFull">
        <el-form ref="formDom" :model="form" :rules="rules" label-position="left" label-width="140px" class="form-wrap" :disabled="!isCurrent || type === 'preview'">
            <el-form-item label="需求名称" prop="title">
                <el-input v-model="form.title" placeholder="请输入需求名称" maxlength="100" show-word-limit />
            </el-form-item>
            <el-form-item label="来源学校">
                <el-select v-model="form.sid" placeholder="请选择学校" filterable clearable @change="schoolChange" style="width: 340px">
                    <el-option :label="item.name" :value="item.id" v-for="item in schoolList" :key="item.id"></el-option>
                </el-select>
                <div class="connect-box" @click="openAssoiate" :style="{'cursor': !isCurrent || type === 'preview' ? 'not-allowed' : 'pointer'}">
                    <img src="@/assets/image/requirement/icon-connect.png" alt="">
                    <span>关联周计划</span>
                </div>
            </el-form-item>
            <el-form-item label="所属产品" prop="productId">
                <el-select v-model="form.productId" placeholder="请选择产品">
                    <el-option :label="item.name" :value="item.id" v-for="item in productList" :key="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="负责销售" prop="saleUserId">
                <el-select v-model="form.saleUserId" placeholder="请选择销售" clearable>
                    <el-option :label="item.name" :value="item.id" v-for="item in salePersonOption.slice(1)" :key="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="提出人" prop="submitUser">
                <el-input v-model="form.submitUser" placeholder="请输入提出人" maxlength="50" show-word-limit />
            </el-form-item>
            <el-form-item label="提出日期" prop="submitDate">
                <el-date-picker v-model="form.submitDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" />
            </el-form-item>
            <el-form-item label="是否有付费意向" prop="payIntention">
                <el-radio-group v-model="form.payIntention">
                    <el-radio :label="1">有付费意向</el-radio>
                    <el-radio :label="0">无付费意向</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="需求详细内容">
                <el-input v-model="form.detail" type="textarea" placeholder="请输入需求详细内容" maxlength="1000" show-word-limit :autosize="{ minRows: 2, maxRows: 6}" />
            </el-form-item>
            <el-form-item label="附件">
                <uploadAtt v-model="form.fileInfoModelList" :bizType="1" :disabled="!isCurrent" />
            </el-form-item>
        </el-form>
        <!-- 底部按钮 -->
        <div class="footer-operation" v-if="type != 'preview' && isCurrent">
            <el-button type="primary" @click="onSubmit" :loading="loadSubmit">下一步</el-button>
        </div>

        <!-- 关联周计划 pc弹窗 -->
        <weekPlanPc :dialogVisible.sync="assoVisible" :count="10" @relatedData="handleRelatedData"></weekPlanPc>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { findRequirementDetail, addRequirement, updateRequirement } from '@/api/requirement'

export default {
    components: {
        uploadAtt: () => import("./uploadAtt.vue"),
        weekPlanPc: () => import("@/views/visit/components/weekPlanPc.vue")
    },
    props: {
        requirementId: [Number, String],
        currentStep: [Number, String],
        // 弹窗类型：add 新增 | edit 编辑 | preview 预览
        type: String,
    },
    data() {
        return {
            loadFull: false,
            form: {
                title: '',
                sid: '',
                logId: '', // 关联的拜访id
                productId: '',
                saleUserId: '',
                submitUser: '',
                submitDate: '',
                payIntention: 1,
                detail: '',
                fileIdList: [],
                fileInfoModelList: [],
            },
            rules: {
                title: [
                    { required: true, message: '请输入', trigger: 'blur' }
                ],
                productId: [
                    { required: true, message: '请选择', trigger: 'blur' }
                ],
                saleUserId: [
                    { required: false, message: '请选择', trigger: 'blur' }
                ],
                submitUser: [
                    { required: true, message: '请选择', trigger: 'blur' }
                ],
                submitDate: [
                    { required: true, message: '请选择', trigger: 'blur' }
                ],
                payIntention: [
                    { required: true, message: '请选择', trigger: 'blur' }
                ],
            },
            loadSubmit: false,
            // 关联拜访
            assoVisible: false,
        }
    },
    computed: {
        ...mapState(["productList", "schoolList", "salePersonOption", "userData"]),
        // 进度是否为当前节点
        isCurrent() {
            return this.currentStep === 1 ? true : false
        }
    },
    methods: {
        // 选择学校
        schoolChange() {
            if (this.form.sid) {
                // 选择了学校，负责销售必填
                this.rules['saleUserId'][0].required = true;
            } else {
                this.rules['saleUserId'][0].required = false;
            }
        },
        // 提交表单
        onSubmit() {
            this.loadSubmit = true;
            this.$refs.formDom.validate(valid => {
                if (valid) {
                    let reqApi = addRequirement;
                    if (this.requirementId) {
                        this.form.id = this.requirementId;
                        reqApi = updateRequirement;
                    }
                    this.form.fileIdList = this.form.fileInfoModelList.map(x => x.id);
                    reqApi(this.form).then(res => {
                        this.loadSubmit = false;
                        this.$emit('push', res.data);
                    }).catch(err => {
                        this.loadSubmit = false;
                        this.$MessageBox.MessageWarning(err.data.msg);
                    })
                } else {
                    this.loadSubmit = false;
                    return;
                }
            })
        },
        // 清空表单校验
        clearForm() {
            this.form.detail = null;
            this.form.sid = '';
            this.form.fileInfoModelList = [];
            this.form.fileIdList = [];
            this.$nextTick(() => {
                this.$refs.formDom?.resetFields();
            })
        },
        // 回显表单信息
        echoInfo() {
            if (!this.requirementId) return;
            this.loadFull = true;
            this.$refs.formDom.resetFields();
            findRequirementDetail({ id: this.requirementId }).then(res => {
                if (res.data) {
                    this.form = { ...res.data }
                    this.form.fileInfoModelList = this.form.fileInfoModelList.map(x => {
                        return {
                            uid: x.id,
                            name: x.fileName,
                            path: x.filePath,
                            id: x.id,
                        }
                    })
                } else {
                    this.clearForm();
                }
                this.loadFull = false;
            }).catch(err => {
                this.loadFull = false;
                this.$MessageBox.MessageWarning(err.data.msg);
            })
        },
        // 打开“关联周计划”弹窗
        openAssoiate() {
            if (this.isCurrent && this.type != 'preview') {
                this.assoVisible = true
            } else {
                this.assoVisible = false
            }
        },
        // 关联周计划回显
        handleRelatedData(data) {
            this.form.sid = data.sid; // 来源学校
            this.form.saleUserId = this.userData.userId; // 负责销售
            this.form.submitDate = data.visitDay; // 提出日期
        },
    }
}
</script>

<style lang="scss" scoped>
.form-wrap {
    width: 600px;
    margin: 0 auto;
    /deep/ .el-form-item {
        .el-form-item__label {
            font-size: 1rem;
        }
        .el-form-item__content {
            > .el-input,
            .el-select,
            .el-textarea {
                width: 100%;
            }
        }
    }
}
.connect-box {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-left: 15px;
    color: #0540c3;
    vertical-align: -3px;
    cursor: pointer;
    img {
        width: 18px;
    }
}
/deep/ .el-textarea {
    .el-textarea__inner {
        padding-bottom: 20px;
    }
    .el-input__count {
        height: 20px;
        line-height: 20px;
        left: 15px;
        text-align: right;
        bottom: 1px;
        right: 25px;
    }
}
.footer-operation {
    display: flex;
    justify-content: center;
    > .el-button {
        height: 32px;
        line-height: 31px;
        padding-top: 0;
        padding-bottom: 0;
    }
}
</style>